import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.farm.check');
import { OnInit, OnChanges, Input, SimpleChanges, ViewChild  } from '@angular/core';
import moment from 'moment';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-farm-check',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.farm.check/view.scss */
/* src/app/portal.farm.check/view.scss: no such file or directory */`],
})
export class PortalFarmCheckComponent implements OnInit, OnChanges {

  @ViewChild('modalMessage') modalMessage: any;

  @Input() farm_id!: string;
  @Input() farm!: any;

  public machines = [];
  public replacepart = [];

  public machine = {
    data: {},
    form: {},
    status: {},
    event: {},
    select: (item) => this.selectMachine(item),
    change: (item) => this.changePart(item)
  };

  private inited = false;

  constructor(@Inject( Service)     public service: Service,  ) {}

  public async ngOnInit() {
    await this.service.init();

    this.inited = true;

    if (!this.farm_id) {
      await this.service.render();
      return;
    }

    await this.loadMachines();

    if (this.machines.length > 0) {
      await this.selectMachine(this.machines[0]);
    }

    await this.service.render();
  }

  public async ngOnChanges(changes: SimpleChanges) {
    const farmChanged = changes['farm_id'];
    if (!farmChanged) return;
    if (!this.inited) return;
    if (!this.farm_id) return;

    await this.loadMachines();

    if (this.machines.length > 0) {
      await this.selectMachine(this.machines[0]);
    } else {
      this.machine.data = {};
      this.replacepart = [];
    }

    await this.service.render();
  }

  private showModal(message): Promise<boolean> {
      return this.modalMessage.open({ message });
  }

  private async loadMachines() {
    const res = await wiz.call('machines', {
      farm_id: this.farm_id
    });

    const rows = Array.isArray(res?.data)
      ? res.data
      : Array.isArray(res?.data?.list)
        ? res.data.list
        : [];

    if (res.code !== 200 || rows.length === 0) {
      this.machines = [];
      return;
    }

    this.machines = rows.map((m) => {
      let machine_condition: any = [];
      let tray: any = [];

      try {
        machine_condition = m.machine_condition ? JSON.parse(m.machine_condition) : [];
      } catch (e: any) {
        machine_condition = [];
      }

      try {
        tray = m.tray ? JSON.parse(m.tray) : [];
      } catch (e: any) {
        tray = [];
      }

      return {
        ...m,
        machine_condition,
        tray,
        installed: m.installed ? new Date(m.installed) : null
      };
    });
  }

  public async selectMachine(item) {
    if (!item || !item.id) {
      this.replacepart = [];
      await this.service.render();
      return;
    }

    this.machine.data = item;

    const res = await wiz.call('replacepart', {
      machine_id: item.id
    });

    const rows = Array.isArray(res?.data)
      ? res.data
      : Array.isArray(res?.data?.list)
        ? res.data.list
        : [];

    if (res.code !== 200 || rows.length === 0) {
      this.replacepart = [];
      await this.service.render();
      return;
    }

  this.replacepart = rows.map((p) => {

    const installedStr = p.installed
      ? moment(p.installed).format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD');

    const installedMoment = moment(installedStr);

    const useday = moment().diff(installedMoment, 'days');

    const perc = p.replace_cycle
      ? (useday * 100) / (p.replace_cycle * 365)
      : 0;

    return {
      ...p,
      machine_id: item.id,
      part_id: p.id,
      installed: installedStr,
      useday,
      perc
    };
  });

    await this.service.render();
  }

  public async changePart(item) {

    const data = {
      machine_id: item.machine_id,
      part_id: item.part_id,
      installed: item.installed
    };

    if (moment(data.installed).isAfter(moment(), 'day')) {
      await this.showModal('현재 날짜 이후 날짜는 등록할수 없습니다.');
      return;
    }

    const res = await wiz.call('update', data);

    if (res.code === 200) {
      toastr.success('저장되었습니다');
      await this.selectMachine(this.machine.data);
      return;
    }

    await this.showModal(res.data);
  }
}

export default PortalFarmCheckComponent;